import { formatZip, Heading, P, SimpleGrid, Stack, useText } from "@sveabank/cc-common";
import Paper from "../../components/paper";
import type { ApplicationDetails } from "../../types/application";

type Props = {
	details: ApplicationDetails;
};

const CompanyInformation = ({ details }: Props) => {
	const [t, texts] = useText();
	return (
		<Paper>
			<Stack gap={2}>
				<Heading.H3 size="h4" italic={false}>
					{details.organization.orgName}
				</Heading.H3>
				<SimpleGrid cols={2}>
					<Stack component="section">
						<Heading.H4 size="base">{t(texts.contactInfo.companyInfo.visitingAddress)}</Heading.H4>
						{!!details.organization.address && (
							<div>
								<P>{details.organization.address.addressLine1}</P>
								<P>{details.organization.address.addressLine2}</P>
								<P>{`${formatZip(details.organization.address.zipCode)} ${
									details.organization.address.city
								}`}</P>
							</div>
						)}
					</Stack>
					<section className="flex flex-col">
						<Heading.H4 size="base">{t(texts.contactInfo.companyInfo.postAddress)}</Heading.H4>
						{!!details.applicant.address && (
							<>
								<P>{details.applicant.address.addressLine1}</P>
								<P>{details.applicant.address.addressLine2}</P>
								<P>{`${formatZip(details.applicant.address.zipCode)} ${
									details.applicant.address.city
								}`}</P>
							</>
						)}
					</section>
				</SimpleGrid>
			</Stack>
		</Paper>
	);
};

export default CompanyInformation;
